import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconButton from '../IconButton';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

const ToolbarButton = ({
  id,
  icon,
  label,
  commands,
  onInteraction,
  dropdownContent,
  className,
  disabled,
  disabledText,
  size,
  isSegmentationToolBar,
  //
  toolTipClassName,
  disableToolTip = false,
  ...rest
  //
}) => {
  const shouldShowDropdown = !!dropdownContent;

  const iconEl = icon ? <Icon name={icon} /> : <div>{label || 'Missing icon and label'}</div>;

  const sizeToUse = size ?? 'toolbar';

  const toolTipClassNameToUse =
    toolTipClassName !== undefined
      ? toolTipClassName
      : sizeToUse === 'toolbar'
        ? 'w-[40px] h-[40px]'
        : 'w-[32px] h-[32px]';

  return (
    <>
      {isSegmentationToolBar ? (
        <div key={`${id}-segmentation`}>
          <Tooltip
            isSticky={shouldShowDropdown}
            content={shouldShowDropdown ? dropdownContent : label}
            secondaryContent={disabled ? disabledText : null}
            tight={shouldShowDropdown}
            className={toolTipClassNameToUse}
            isDisabled={disableToolTip}
          >
            <IconButton
              size={sizeToUse}
              className={classNames(className, disabled ? 'ohif-disabled' : '')}
              onClick={() => {
                onInteraction({
                  itemId: id,
                  commands,
                });
              }}
              name={label}
              key={id}
              id={id}
              {...rest}
            >
              {iconEl}
            </IconButton>
          </Tooltip>
        </div>
      ) : (
        <div
          key={id}
          className="mx-2 flex flex-col items-center"
        >
          <IconButton
            size={sizeToUse}
            className={classNames(className, disabled ? 'ohif-disabled' : '')}
            onClick={() => {
              onInteraction?.({
                itemId: id,
                commands,
              });
            }}
            name={label}
            id={id}
            disabled={disabled}
            {...rest}
          >
            {iconEl}
          </IconButton>
          {label && <span className="mt-1 text-center text-xs text-black">{label}</span>}
        </div>
      )}
    </>
  );
};

ToolbarButton.defaultProps = {
  dropdownContent: null,
  isSegmentationToolBar: false,
};

ToolbarButton.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  commands: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  onInteraction: PropTypes.func,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  isSegmentationToolBar: PropTypes.bool,
  toolTipClassName: PropTypes.string,
};

export default ToolbarButton;
